import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { takeUntil } from 'rxjs';
import { AlertService } from '@src/core/services';
import { BaseComponent } from '@src/app/modules/base';
import { EnvService } from '@src/app/modules/env';
import { FileType } from '@src/app/modules/images-group-view';

import { MessageModel } from '../types';
import { MessageService } from '../services';

import {
  MAX_HEIGHT_IMAGE_DESKTOP,
  MAX_WIDTH_IMAGE_DESKTOP,
  MAX_HEIGHT_IMAGE_MOBILE,
  MAX_WIDTH_IMAGE_MOBILE,
} from './constants';

@Component({
  selector: 'message-image',
  templateUrl: './message-image.component.html',
  styleUrls: ['./message-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class MessageImageComponent extends BaseComponent implements OnInit {
  private readonly messageService = inject(MessageService);
  private readonly alertService = inject(AlertService);
  private readonly env = inject(EnvService);

  @Input() message!: MessageModel;

  filesForGroup: FileType[] = [];

  readonly maxWidth = this.env.isMobilePlatform ? MAX_WIDTH_IMAGE_MOBILE : MAX_WIDTH_IMAGE_DESKTOP;
  readonly maxHeight = this.env.isMobilePlatform ? MAX_HEIGHT_IMAGE_MOBILE : MAX_HEIGHT_IMAGE_DESKTOP;

  get files() {
    return this.message.content.files ?? [];
  }

  ngOnInit(): void {
    this.files.forEach((file, index) => {
      const fileId = file.fileId;
      const chatId = this.message.chatId;

      if (fileId && chatId) {
        this.messageService
          .downloadMessageFile(fileId, chatId)
          .pipe(takeUntil(this.destroyed$$))
          .subscribe({
            next: blob => {
              // INFO: чтобы сохранить последовательность файлов
              this.filesForGroup[index] = {
                blob,
                fileName: file.fileName ?? undefined,
              };

              this.filesForGroup = [...this.filesForGroup];
              this.cdr.markForCheck();
            },
            error: err => {
              this.alertService.error(err);
            },
            complete: () => {
              this.cdr.markForCheck();
            },
          });
      }
    });
  }
}
